import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';

export const sliderApi = createApi({
  reducerPath: 'Slider',
  tagTypes: ['Slider'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getVehicleSliderImages: builder.query({
      query: ({ id }) => ({
        url: `/v1/vehicles/images/${id}`,
      }),
    }),

    uploadVehicleSliderImages: builder.mutation({
      query: ({ id, body = {} }) => ({
        url: `/v1/documents/contractor/upload/vehicles/${id}`,
        method: 'POST',
        body,
        extra: true,
      }),
    }),
  }),
});

export const {
  useLazyGetVehicleSliderImagesQuery,
  useUploadVehicleSliderImagesMutation,
} = sliderApi;
